<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="ma-0 pa-0">
      <v-list class="pt-0">
        <v-row>
          <v-col cols="11" class="pt-0">
            <Pagination v-model="indexesHistory" @navigateBackward="goBackward" />
          </v-col>
          <v-col>
            <MobileActions
              ref="mobileActions"
              :allowCreate="allowCreate"
              :path="currentPath"
              :allowUpload="allowUpload"
              @upload="uploadFiles"
              @error="showInvalidFiles"
              @refresh="refreshFilesList"
              @create-folder="createFolder"
            />
          </v-col>
        </v-row>
        <v-divider/>
        <flash-message></flash-message>
        <v-overlay :value="loadingError" :opacity="0">
          <v-subheader class="foreground--text">Não foi possível carregar os dados</v-subheader>
        </v-overlay>
        <v-overlay :value="notInicialized" :opacity="0">
          <v-subheader class="foreground--text">Seu Drive não foi iniciado, entre em contato pelo Atendimento.</v-subheader>
        </v-overlay>
        <div v-show="notInicializedSalesforce" class="overlayNotInicializedSf">
          <v-subheader class="foreground--text">Seu Drive não foi iniciado, entre em contato pelo Atendimento.</v-subheader>
        </div>
        <v-overlay :value="isLoadingContent" :opacity="0">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </v-overlay>
        <template v-if="!isLoadingContent && !isLoadingError">
          <GenericInformation :open="detaillingItem" :item="itemToDetail" @close="detaillingItem = false"/>
          <DeletionConfirmationModal  :open="deletingItem" :item="itemToDelete" @close="stopDeletingItem" @confirm="confirmItemDeletion"/>
          <RenamingModal :open="renamingItem" :item="itemToRename" @close="stopRenamingItem" @confirm="confirmItemRenaming"/>
          <GenericFilesExplorerMobile
            v-if="$resize && $mq.below(600)"
            :loadingError="loadingError"
            :notInicialized="notInicialized"
            :notInicializedSalesforce="notInicializedSalesforce"
            :allowCreate="allowCreate"
            :allowUpload="allowUpload"
            :allowRename="allowRename"
            :allowDelete="allowDelete"
            :folders="folders"
            :files="files"
            @create-folder="createFolder"
            @upload="uploadFiles"
            @error="showInvalidFiles"
            @forward="goForward"
            @informations="showItemInformations"
            @manualNotification="manualNotification"
            @download="downloadFile"
            @downloadAllFiles="downloadAllFiles"
            @delete="deleteItem"
            @rename="renameItem"
          />
          <GenericFilesExplorerDesktop
            v-else
            :loadingError="loadingError"
            :notInicialized="notInicialized"
            :notInicializedSalesforce="notInicializedSalesforce"
            :allowCreate="allowCreate"
            :allowUpload="allowUpload"
            :allowRename="allowRename"
            :allowDelete="allowDelete"
            :folders="folders"
            :files="files"
            @forward="goForward"
            @informations="showItemInformations"
            @manualNotification="manualNotification"
            @download="downloadFile"
            @downloadAllFiles="downloadAllFiles"
            @delete="deleteItem"
            @rename="renameItem"
          />
        </template>
      </v-list>
    </v-col>

    <v-col cols="12">
      <ManuallyNotificationDialog :isDialogOpen="isNotificationDialogOpen" @closeManuallyNotificationDialog="closeManuallyNotificationDialog"
        @sendNotificationByDialog="sendNotificationByDialog"/>
    </v-col>
  </v-row>
</template>

<script>
import saveAs from 'file-saver';
import GenericInformation from '@/components/generic-information/index.vue';
import Pagination from '@/components/pagination/index.vue';
import MobileActions from '@/components/mobile-actions/index.vue';
import DeletionConfirmationModal from '@/components/deletion-confirmation-modal/index.vue';
import RenamingModal from '@/components/renaming-modal/index.vue';
import ManuallyNotificationDialog from '@/components/notification/ManuallyNotificationDialog.vue';
import {
  createManuallyNotification, getImplantation,
  createDirectory, deleteDirectory, getDirectory, downloadFile, downloadFileZip, deleteFile,
  renameFile, uploadFile, MESSAGE_ERRO, MESSAGE_NOT_AUTORIZED,
  EMPTY_DIRECTORY, MESSAGE_FILE_EXISTING, MESSAGE_FOLDER_EXISTING, FAILED_LOAD_FILES, MESSAGE_MAX_SIZE_DOWNLOAD,
  MEDIA_TYPE_DIRECTORY, MEDIA_TYPE_FILE, MEDIA_TYPE_ALL_DIALOG,
} from '@/common/driveserver';
import AttachmentMixins from '@/shared/mixins/attachmentMixins';
import FileMixin from '@/shared/mixins/fileMixin';
import GenericFilesExplorerMobile from './index-mobile.vue';
import GenericFilesExplorerDesktop from './index-desktop.vue';
import store from '../../common/store';

export default {
  name: 'GenericFilesExplorer',
  components: {
    GenericFilesExplorerMobile,
    GenericFilesExplorerDesktop,
    GenericInformation,
    Pagination,
    MobileActions,
    DeletionConfirmationModal,
    RenamingModal,
    ManuallyNotificationDialog,
  },
  props: {
    content: {
      type: Object,
    },
    loadingContent: {
      type: Boolean,
    },
    loadingError: {
      type: Boolean,
      required: true,
    },
    notInicialized: {
      type: Boolean,
      required: true,
    },
    notInicializedSalesforce: {
      type: Boolean,
      required: true,
    },
    allowCreate: {
      type: Boolean,
      required: true,
    },
    allowDelete: {
      type: Boolean,
      required: true,
    },
    allowRename: {
      type: Boolean,
      required: true,
    },
    allowUpload: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    count: 0,
    itemsProcessed: 1,
    errosFile: [],
    fileInformationItem: null,
    isLoadingContent: true,
    isLoadingError: false,
    configuredContent: [],
    currentPath: '',
    indexesHistory: [{
      index: 0,
      name: 'Home',
      path: '',
      icon: 'mdi-home',
    }],
    detaillingItem: false,
    deletingItem: false,
    itemToDelete: {},
    renamingItem: false,
    itemToRename: {},
    itemToDetail: {},
    isNotificationDialogOpen: false,
    driveCredentialCode: null,
    inImplantation: false,
  }),
  mixins: [
    AttachmentMixins,
    FileMixin,
  ],
  computed: {
    folders() {
      return this.configuredContent.filter((item) => item.type === 'FOLDER');
    },
    files() {
      return this.configuredContent.filter((item) => item.type === 'FILE');
    },
  },
  methods: {
    saveIndexesHistorySessionStorage() {
      store.saveIndexesHistory(this.indexesHistory);
    },
    goForward(newIndex) {
      if (this.detaillingItem) {
        return;
      }
      if (newIndex >= 0) {
        const folderToNavigateTo = this.folders[newIndex];
        this.indexesHistory.push({
          index: newIndex,
          name: folderToNavigateTo.name,
          path: folderToNavigateTo.path,
        });
        this.showLoad();
        this.getDirectoryService(folderToNavigateTo.path);
        this.currentPath = folderToNavigateTo.path;
      }
      this.saveIndexesHistorySessionStorage();
    },
    goBackward(to) {
      if (to === 0) {
        this.goToIndexHistoryInitial();
        this.showLoad();
        this.getDirectoryService();
      } else {
        if (to === this.indexesHistory.length - 1) {
          return;
        }
        const pathToCut = [];
        this.indexesHistory.forEach((item, index) => {
          if (index <= to) {
            pathToCut.push(item);
          }
        });
        this.getDirectoryService(this.indexesHistory[to].path);
        this.currentPath = this.indexesHistory[to].path;
        this.indexesHistory = pathToCut;
      }
      this.saveIndexesHistorySessionStorage();
    },
    goToIndexHistoryInitial() {
      this.currentPath = '';
      this.indexesHistory = [{
        index: 0,
        name: 'Home',
        path: '',
        icon: 'mdi-home',
      }];
    },
    getDirectoryService(path = '') {
      this.showLoad();
      if (this.inImplantation) {
        getImplantation(path)
          .then((response) => {
            this.configuredContent = response.data.files;
            this.allowCreate = response.data.allowCreate;
            this.allowDelete = response.data.allowDelete;
            this.allowRename = response.data.allowRename;
            this.allowUpload = response.data.allowUpload;
          })
          .catch((error) => {
            this.showMessageErro(error);
          })
          .finally(() => { this.hiddenLoad(); });
      } else {
        getDirectory(path)
          .then((response) => {
            this.configuredContent = response.data.files;
            this.allowCreate = response.data.allowCreate;
            this.allowDelete = response.data.allowDelete;
            this.allowRename = response.data.allowRename;
            this.allowUpload = response.data.allowUpload;
          })
          .catch((error) => {
            this.showMessageErro(error);
          })
          .finally(() => { this.hiddenLoad(); });
      }
    },
    traverseItems(itemsToTraverse, indexToReach) {
      let itemToReturn;
      itemsToTraverse.forEach((item, index) => {
        if (index === indexToReach) {
          itemToReturn = item;
        }
      });
      return itemToReturn;
    },
    traversePath(pathToTraverse) {
      let itemsToTraverse = this.content;
      let lastItemFound;
      pathToTraverse.forEach((pathIndex) => {
        lastItemFound = this.traverseItems(itemsToTraverse, pathIndex);
        itemsToTraverse = lastItemFound.content;
      });
      return lastItemFound;
    },
    showItemInformations(file) {
      this.detaillingItem = true;
      this.itemToDetail = file;
    },
    manualNotification(item) {
      this.fileInformationItem = item;
      this.isNotificationDialogOpen = true;
    },
    closeManuallyNotificationDialog() {
      this.isNotificationDialogOpen = false;
    },
    sendNotificationByDialog(notificationConfig) {
      const newNotificationConfig = { ...notificationConfig };
      newNotificationConfig.pathFileDir = this.fileInformationItem && this.fileInformationItem.path ? this.fileInformationItem.path : '';
      this.isNotificationDialogOpen = false;
      this.isLoadingContent = true;
      if (newNotificationConfig && newNotificationConfig.deliveryChannels && newNotificationConfig.deliveryChannels.length > 0) {
        this.sendManuallyNotification(newNotificationConfig, MEDIA_TYPE_ALL_DIALOG);
      }
    },
    downloadAllFiles(files) {
      const allowedFiles = files.map((file) => ({
        ...file,
        selected: true,
      }));

      const basePath = this.commonPath(allowedFiles.map((f) => f.path));

      const file = { path: basePath };

      const isMaxSizeLimit = this.isMaxSizeLimit(allowedFiles);
      if (isMaxSizeLimit) {
        this.flash(MESSAGE_MAX_SIZE_DOWNLOAD, 'error', { timeout: 5000 });
      } else {
        this.downloadFile(file, allowedFiles);
      }
    },
    downloadFile(file, files) {
      this.showLoad();
      const selectedFiles = files.filter((f) => f.selected === true).map((f) => f.path);
      if (selectedFiles.length > 1) {
        downloadFileZip(file.path, selectedFiles)
          .then((response) => {
            const { path } = file;
            const parts = path.split('/');
            const path1 = parts[parts.length - 2] || 'Arquivos';
            saveAs(new Blob([response.data]), `${path1}.zip`);
          })
          .catch((error) => { this.showMessageErro(error); })
          .finally(() => { this.hiddenLoad(); });
      } else {
        downloadFile(file.path, selectedFiles)
          .then((response) => {
            saveAs(new Blob([response.data]), file.name);
          })
          .catch((error) => { this.showMessageErro(error); })
          .finally(() => { this.hiddenLoad(); });
      }
    },
    isMaxSizeLimit(files) {
      let sizeSum = 0;

      if (files.length > 1) {
        files.forEach((file) => {
          const size = parseFloat(file.size.replace(/[a-z]/gi, ''));
          if (file.size.includes('GB') || file.size.includes('TB')) {
            sizeSum = 120;
          } else if (file.size.includes('MB')) {
            sizeSum += size;
          } else {
            sizeSum += (size / 1000);
          }
        });

        if (sizeSum >= 120) {
          return true;
        }
      }
      return false;
    },
    deleteItem(file) {
      this.itemToDelete = file;
      this.deletingItem = true;
    },
    stopDeletingItem() {
      this.deletingItem = false;
      this.itemToDelete = {};
    },
    confirmItemDeletion() {
      this.deletingItem = false;
      if (this.itemToDelete.type === 'FOLDER') {
        this.deleteDirectoryService();
      } else {
        this.deleteDirectoryFile();
      }
    },
    deleteDirectoryService() {
      this.showLoad();
      deleteDirectory(this.itemToDelete.path, this.itemToDelete.name)
        .then(() => {
          const index = this.findObject(this.itemToDelete.path, this.itemToDelete.name);
          this.configuredContent.splice(index, 1);
        })
        .catch((error) => { this.showMessageErro(error); })
        .finally(() => { this.hiddenLoad(); });
    },
    deleteDirectoryFile() {
      this.showLoad();
      deleteFile(this.itemToDelete.path, this.itemToDelete.name)
        .then(() => {
          const index = this.findObject(this.itemToDelete.path);
          this.configuredContent.splice(index, 1);
        })
        .catch((error) => { this.showMessageErro(error); })
        .finally(() => { this.hiddenLoad(); });
    },
    renameItem(file) {
      this.itemToRename = file;
      this.renamingItem = true;
    },
    stopRenamingItem() {
      this.renamingItem = false;
      this.itemToRename = {};
    },
    confirmItemRenaming(newName = 'newName') {
      this.renamingItem = false;
      this.renameFileService(newName);
    },
    renameFileService(newName) {
      this.showLoad();
      const path = this.itemToRename.path.replace(this.itemToRename.name, '');
      renameFile(path, newName, this.itemToRename.name)
        .then((response) => {
          const index = this.findObject(this.itemToRename.path);
          this.configuredContent[index].name = response.data.name;
          this.configuredContent[index].path = path.concat(response.data.name);
          this.configuredContent[index].modified = response.data.modified;
        })
        .catch((error) => {
          this.showMessageErro(error);
        })
        .finally(() => { this.hiddenLoad(); this.itemToRename = {}; });
    },
    uploadFiles(paramsUpload) {
      const { files, notificationConfig } = paramsUpload;
      this.showLoad();
      this.count = files.length;
      this.itemsProcessed = 1;
      this.errosFile = [];

      if (!this.validateBase64FilesSize(files)) return;

      files.forEach((item, index) => {
        this.uploadFileService(files[index], this.currentPath, files, index, notificationConfig);
      });
    },
    uploadFileService(file, pathFile, selectedFiles, index, notificationConfig) {
      uploadFile(pathFile, file.name, file.body, file.data)
        .then((response) => {
          this.configuredContent.push({
            name: decodeURI(response.data.name),
            path: decodeURI(pathFile.concat('/').concat(response.data.name)),
            type: response.data.type,
            created: response.data.created,
            modified: response.data.modified,
            userName: decodeURI(response.data.userName),
            userNameUpdate: decodeURI(response.data.userNameUpdate),
            size: response.data.size,
            content: [],
          });
          selectedFiles.splice(index, 1);

          if (notificationConfig && notificationConfig.deliveryChannels && notificationConfig.deliveryChannels.length > 0) {
            this.sendManuallyNotification(notificationConfig, MEDIA_TYPE_FILE);
          }
        })
        .catch((error) => {
          this.errosFile.push({
            name: file.name,
            status: error.response.status,
            error: error.response,
          });
        })
        .finally(() => {
          if (this.itemsProcessed === this.count) {
            this.hiddenLoad();
            const invalidFiles = [];
            const fileExisting = [];
            const fileFailed = [];

            this.errosFile.forEach((item) => {
              switch (item.status) {
                case 409:
                  fileExisting.push(item.name);
                  break;

                case 413:
                  invalidFiles.push(item);
                  break;

                default:
                  fileFailed.push(item.name);
              }
            });
            if (fileExisting.length > 0) {
              this.flash(`${MESSAGE_FILE_EXISTING}: ${fileExisting.toString()}`, 'error', { timeout: 5000 });
            }
            if (fileFailed.length > 0) {
              this.flash(`${FAILED_LOAD_FILES}: ${fileFailed.toString()}`, 'error', { timeout: 5000 });
            }
            if (invalidFiles.length > 0) {
              this.showServiceInvalidErrors(invalidFiles);
            }
          }
          this.itemsProcessed += 1;
        });
    },
    refreshFilesList(response) {
      response.forEach((item) => {
        this.configuredContent.push({
          name: decodeURI(item.name),
          path: decodeURI(this.currentPath.concat('/').concat(item.name)),
          type: item.type,
          created: item.created,
          modified: item.modified,
          userName: decodeURI(item.userName),
          userNameUpdate: decodeURI(item.userNameUpdate),
          size: item.size,
          content: [],
        });
      });
    },
    createFolder(paramsFolder) {
      this.showLoad();
      const path = this.currentPath;
      const { newName, notificationConfig } = paramsFolder;
      createDirectory(path, newName)
        .then((response) => {
          this.configuredContent.push({
            name: decodeURI(response.data.name),
            path: decodeURI(path.concat('/').concat(newName)),
            type: response.data.type,
            created: response.data.created,
            modified: response.data.modified,
            userName: decodeURI(response.data.userName),
            userNameUpdate: decodeURI(response.data.userNameUpdate),
            size: response.data.size,
            content: [],
          });

          if (notificationConfig && notificationConfig.deliveryChannels && notificationConfig.deliveryChannels.length > 0) {
            this.sendManuallyNotification(notificationConfig, MEDIA_TYPE_DIRECTORY);
          }
        })
        .catch((error) => { this.showMessageErro(error); })
        .finally(() => { this.hiddenLoad(); });
    },
    async sendManuallyNotification(notificationConfig, mediaType) {
      if (this.driveCredentialCode === 'healthcare-drive') {
        // eslint-disable-next-line no-param-reassign
        notificationConfig.isHealthcareDrive = true;
      }

      await createManuallyNotification(notificationConfig)
        .then(() => {})
        .finally(() => {
          if (this.$refs.mobileActions && mediaType === MEDIA_TYPE_FILE) {
            this.$refs.mobileActions.$refs.filePickerMobile.$refs.inputFileMobile.clearNotificationFields();
          }
          if (mediaType === MEDIA_TYPE_ALL_DIALOG) {
            this.isLoadingContent = false;
            this.flash('Os usuários foram notificados com sucesso.', 'success', { timeout: 5000 });
          }
        });
    },
    findObject(path) {
      return this.configuredContent.findIndex((r) => r.path === path);
    },
    showLoad() {
      this.isLoadingContent = true;
    },
    hiddenLoad() {
      this.isLoadingContent = false;
    },
    showMessageErro(error) {
      this.hiddenLoad();
      let message;
      switch (error.response.status) {
        case 401:
          message = MESSAGE_NOT_AUTORIZED;
          break;
        case 409:
          if (error.response.data.toUpperCase() === 'RESOURCEALREADYEXISTS') {
            message = MESSAGE_FOLDER_EXISTING;
          }
          if (error.response.data.toUpperCase() === 'DIRECTORYNOTEMPTY') {
            message = EMPTY_DIRECTORY;
          }
          break;
        default:
          message = MESSAGE_ERRO;
      }
      this.flash(message, 'error', { timeout: 5000 });
    },
  },
  watch: {
    content(newContent) {
      this.configuredContent = newContent.files;
    },
    loadingContent(loadingContent) {
      this.isLoadingContent = loadingContent;
    },
  },
  created() {
    this.inImplantation = this.$router
      && this.$router.currentRoute
      && this.$router.currentRoute.query
      && this.$router.currentRoute.query.implantation === 'true';

    this.driveCredentialCode = this.$route.query ? this.$route.query.driveCredentialCode : null;
    this.saveIndexesHistorySessionStorage();
  },
};

</script>

<style lang="scss">
  .overlayNotInicializedSf {
    position: absolute;
    top: 220px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 300px;
  }
</style>
